import {
  AccessorialsDetails,
  DestinationDetails,
  HazmatAccessorials,
  LatestTracknum,
  OriginDetails,
} from 'src/app/core/models/package-tracking.model';

export const CONSTS = {
  TRACKING_NUMBER: $localize`Tracking Number`,
  PACKAGE_INQUIRY: $localize`Package Inquiry`,
  PACKAGE_HISTORY: $localize`Package History`,
};

export const PACKAGE_TABS = {
  INQUIRY: $localize`inquiry`,
  HISTORY: $localize`history`,
};

export const EXCEL_FILE_NAME = 'package-history';

export type PackageTrackingDataType = {
  searchQuery: string;
  originDetails: OriginDetails[];
  destinationDetails: DestinationDetails[];
  accessorials: AccessorialsDetails[];
  hazmatAccessorials: HazmatAccessorials[];
  latestTracknum?: LatestTracknum[];
};
